import { render, staticRenderFns } from "./request-details.modal.vue?vue&type=template&id=66c839aa&scoped=true"
import script from "./request-details.modal.vue?vue&type=script&lang=js"
export * from "./request-details.modal.vue?vue&type=script&lang=js"
import style0 from "./request-details.modal.vue?vue&type=style&index=0&id=66c839aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c839aa",
  null
  
)

export default component.exports